import none from '../../img/leoLogo.png'
import pirashki from '../../img/cake/pirashki.jpg'

export const cake=[
    {
      "id": "151",
      "title": "چیز کیک روز",
      "desciption": "",
      "price": "121",
      "image": none
    },
    {
      "id": "152",
      "title": "وافل",
      "desciption": "",
      "price": "235",
      "image": none
    },
    {
      "id": "153",
      "title": "کیک روز",
      "desciption": "",
      "price": "123",
      "image": none
    },
    // {
    //   "id": "154",
    //   "title": "کیک ولنتاین",
    //   "desciption": "",
    //   "price": "70",
    //   "image": none
    // },
    // {
    //   "id": "155",
    //   "title": "پیراشکی روز",
    //   "desciption": "",
    //   "price": "75",
    //   "image": pirashki
    // },
    {
      "id": "156",
      "title": "colorfull dream",
      "desciption": "ویفر ، موز، بستنی توت فرنگی، خامه، بیسکوییت",
      "price": "223",
      "image": none
    },
    {
      "id": "157",
      "title": "کروسان شکلاتی",
      "desciption": "",
      "price": "140",
      "image": none
    },
    {
      "id": "158",
      "title": "باقلوا",
      "desciption": "4 عدد",
      "price": "110",
      "image": none
    },
  ]